import { render, staticRenderFns } from "./CoSelect.vue?vue&type=template&id=d3bdfc0a&scoped=true&"
import script from "./CoSelect.vue?vue&type=script&lang=ts&"
export * from "./CoSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CoSelect.vue?vue&type=style&index=0&id=d3bdfc0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bdfc0a",
  null
  
)

export default component.exports